export class MinLengthError extends Error {
  constructor(minLength: string) {
    super(`O campo deve ter no mínimo ${minLength} caracteres`);
  }
}
